/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IFooterViewProps } from '@msdyn365-commerce-modules/footer';
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

/**
 *
 * FooterItemView component
 * @extends {React.PureComponent<IFooterViewProps>}
 */
export class FooterItemView extends React.PureComponent<IFooterViewProps> {
  private pathName: string = '';
  public render(): JSX.Element | null {
    const { FooterItem } = this.props;
    return <Module {...FooterItem}>{this._renderElement(this.props)}</Module>;
  }

  private _renderElement(props: IFooterViewProps): React.ReactNode | null {
    const { heading, HeadingContainer, Link, linkText, image, text } = props;
    const { link } = this.props.config;
    if (Link) {
      this._formatLinkData(Link);
    }
    if (heading && text) {
      return (
        <>
          <Node {...HeadingContainer}> {heading}</Node>
          {text}
          <Node {...Link} aria-label={link?.ariaLabel}>
            {linkText}
            {image}
            <span className='rightArrow'></span>
          </Node>
        </>
      );
    } else if (heading) {
      (<Node {...HeadingContainer}> {heading}</Node>);
    } else if (Link) {
      const linkChecker = this._getPathNameFromURL(link!.linkUrl.destinationUrl.toString());
      if (process.env.CURRENT_ENVIRONMENT === 'web') {
        this.pathName = window.location.pathname;
      } else {
        this.pathName = this.props.context.request.url.requestUrl.pathname;
      }
      if(linkChecker === this.pathName){
        return (
          <Node {...Link} aria-current='page' aria-label={link?.ariaLabel}>
            {linkText}
            <span className='footer-separator' aria-hidden='true'>|</span>
            {image}
          </Node>
        );
      }
      return (
        <Node {...Link} aria-label={link?.ariaLabel}>
          {linkText}
          <span className='footer-separator' aria-hidden='true'>|</span>
          {image}
        </Node>
      );
    }
    return (
      <>
        {linkText}
        {image}
      </>
    );
  }

  private _formatLinkData = (Link: INodeProps) => {
    if (Link.href === undefined) {
      return Link;
    }

    const path: string = (Link.href as Msdyn365.ILinkData).destinationUrl || (Link.href as string);
    const newUrl = new URL(path, this.props.context.request.url.requestUrl).href;
    Link.href = newUrl;
    return Link;
  };
  private _getPathNameFromURL(linkURL: string): string {
    let pathName = '';
    try {
      // if linkURL is a full url
      pathName = new URL(linkURL).pathname;
    } catch {
      pathName = linkURL.split('?')[0];
    }
    return pathName;
  }

}

export default FooterItemView;
